/**
 *
 *
 * pc端 下拉题
 *
 * 手机端答题页已经在前面路由到其他组件了
 *
 * optionForm === 1
 *
 *
 */
import React from "react";
import { AQ, QA } from "./web";

export default (props) => {
  console.log(`src\\pages\\matrix\\MatrixSelect\\index.jsx`);
  const { info } = props;
  const {
    preferences: {
      childPrefer: { direction },
    },
  } = info;

  return direction ? <AQ {...props} /> : <QA {...props} />;
};
